import React, { ReactNode } from 'react';
import name from './name';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldBase = {
  kind?: '' | 'prefixed' | 'suffixed' | 'password' | 'multiline' | 'licensePlate' | 'phoneNumber' | 'autofill';
  ariaLive?: 'off' | 'polite' | 'assertive';
  children: ReactNode;
};

const TextFieldBase = ({ kind = '', ariaLive, ...rest }: TTextFieldBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
    'aria-live': ariaLive,
  });
  return <Box {...rest} {...conditionalProps} name={name} as="div" />;
};

export default TextFieldBase;
